module.exports = __webpack_public_path__ + "assets/b78.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b78.png
// module id = 669
// module chunks = 0